// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomVerticalIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomVerticalIcon" ref={forwardedRef} {...props}>
      <path d="M11.828 17.172 9 20l-2.828-2.828 1.062-1.063 1.77 1.77 1.765-1.766z" />
      <path d="M6.172 2.828 9 0l2.828 2.828-1.062 1.063-1.77-1.77-1.765 1.766z" />
      <path d="M11.172 14.505a5 5 0 1 1 1.605-1.228l2.556 2.547a1 1 0 0 1-.001 1.413 1.005 1.005 0 0 1-1.418.001zM12.5 10a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ZoomVerticalIcon = /* @__PURE__ */ Object.assign(
  ZoomVerticalIconComponent,
  { displayName: 'ZoomVerticalIcon' },
);
